<template>

  <div class="movie-index">

    <div class="movie-bn">
      <img src="../../assets/img/bn1.jpg">
    </div>

    <div class="search-word">
      <button @click="toVodSearch" class="s" style="width: 100%;"><span>搜索视频</span></button>
      <!-- <button @click="showNav = !showNav" class="n"><span v-if="!showNav">显示分类</span><span v-else class="up">隐藏分类</span></button> -->
    </div>

        <!-- 导航 -->
        <div class="hd-nav">
        <ul>
          <li class="i12"  @click="toCategory(1)">今日推荐</li>
          <li class="i4" @click="toHistory">已购视频</li>
          <li class="i11" @click="toPurchase">会员</li>
          <li v-if="inAndroidBrowser" class="i3" @click="downloadAndroidApp">APP</li>
          <li v-if="inIosBrowser" class="i3" @click="showIosFixDesktopStep=true">APP</li>
          <li class="i5"  @click="toVodSearch">搜视频</li>
        </ul>
      </div>


    <div class="movie-nav" v-if="showNav">
      <ul>
        <li v-for="(item, index) in homeShelves" :key="index"  @click="toCategory(item.typeId)"><span></span><h5>{{ item.typeName }}</h5></li>
      </ul>
    </div>

    <div class="movie-box movie-box-home">
      <h3><span class="icon-h3-new">每日更新</span><i @click="toCategory(0)" style="background: #58814f;">更多 >></i></h3>
      <div class="movie-box-flex">
        <div  class="f-x">
          <div class="item"  v-for="(item, i) in homeDaily" :key="i" @click="toVodDetail(item)">
            <a class="img">
              <img imgtype="vod" :imgpath="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
              <div class="vip-free" v-show="item.vipFree"></div>
            </a>
            <h5>{{item.vodName}}</h5>
            <div class="ico"></div>

          </div>
        </div>

      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-1"  @click="toCategory(1)">{{ id_1_name }}</span><i @click="toCategory(1)">更多 >></i><i class="ccc refresh" @click="getVodCategory(1)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item" v-for="(item, i) in id_1_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-2"  @click="toCategory(2)">{{ id_2_name }}</span><i @click="toCategory(2)">更多 >></i><i class="ccc refresh" @click="getVodCategory(2)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item" v-for="(item, i) in id_2_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-3"  @click="toCategory(3)">{{ id_3_name }}</span><i @click="toRanking()">更多 >></i><i class="ccc refresh" @click="getVodCategory(3)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_3_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-4"  @click="toCategory(4)">{{ id_4_name }}</span><i @click="toCategory(4)">更多 >></i><i class="ccc refresh" @click="getVodCategory(4)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_4_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-5"  @click="toCategory(5)">{{ id_5_name }}</span><i @click="toCategory(5)">更多 >></i><i class="ccc refresh" @click="getVodCategory(5)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_5_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-6"  @click="toCategory(6)">{{ id_6_name }}</span><i @click="toCategory(6)">更多 >></i><i class="ccc refresh" @click="getVodCategory(6)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_6_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-7"  @click="toCategory(7)">{{ id_7_name }}</span><i @click="toCategory(7)">更多 >></i><i class="ccc refresh" @click="getVodCategory(7)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_7_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-8"  @click="toCategory(8)">{{ id_8_name }}</span><i @click="toCategory(8)">更多 >></i><i class="ccc refresh" @click="getVodCategory(8)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_8_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-9"  @click="toCategory(9)">{{ id_9_name }}</span><i @click="toCategory(9)">更多 >></i><i class="ccc refresh" @click="getVodCategory(9)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_9_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="movie-box">
      <h3><span class="icon-h3-10"  @click="toCategory(10)">{{ id_10_name }}</span><i @click="toCategory(10)">更多 >></i><i class="ccc refresh" @click="getVodCategory(10)">换一批</i></h3>
      <div class="movie-box-flex">
        <div class="item"  v-for="(item, i) in id_10_list" :key="i" @click="toVodDetail(item)">
          <a class="img">
            <img imgtype="vod" :imgpath="item.vodPic" :src="item.vodPic" v-lazy="require('../../assets/images/loading.jpeg')" @click="toVodDetail(item)"/>
            <div class="vip-free" v-show="item.vipFree"></div>
          </a>
          <h5>{{item.vodName}}</h5>
        </div>
      </div>
    </div>

    <div class="download-pops" v-if="inAndroidBrowser && !inWebView" @click="downloadAndroidApp">
      <div class="tx">下载APP，每日领金币</div>
    </div>

    <div v-show="isLoading" class="loadingBox">加载中</div>

    <vodBottom></vodBottom>

  </div>


</template>

<script>
import vodBottom from '@/components/layer1/bottomIndex'
import vodService from "../../services/vodService";
import userService from "../../services/userService";
import kkUtil from "../../assets/js/kk-util";

export default {
  name: "vod",
  data() {
    return {
      showIosFixDesktopStep: false,
      inWebView: false,
      inAndroidBrowser: false,
      inIosBrowser: false,

      componentName: '',
      selected: {
        category: '0',
        publish: 'all'
      },
      isLoading: false,
      userInfo: '',
      homeShelves: '',
      shelfPage: 0,
      id_1_name:'',
      id_1_list:[],
      id_1_page: 1,
      id_1_current: [],
      id_1_total_page: 1,
      id_2_name:'',
      id_2_list:[],
      id_2_page: 1,
      id_2_current: [],
      id_2_total_page: 1,
      id_3_name:'',
      id_3_list:[],
      id_3_page: 1,
      id_3_current: [],
      id_3_total_page: 1,
      id_4_name:'',
      id_4_list:[],
      id_4_page: 1,
      id_4_current: [],
      id_4_total_page: 1,
      id_5_name:'',
      id_5_list:[],
      id_5_page: 1,
      id_5_current: [],
      id_5_total_page: 1,
      id_6_name:'',
      id_6_list:[],
      id_6_page: 1,
      id_6_current: [],
      id_6_total_page: 1,
      id_7_name:'',
      id_7_list:[],
      id_7_page: 1,
      id_7_current: [],
      id_7_total_page: 1,
      id_8_name:'',
      id_8_list:[],
      id_8_page: 1,
      id_8_current: [],
      id_8_total_page: 1,
      id_9_name:'',
      id_9_list:[],
      id_9_page: 1,
      id_9_current: [],
      id_9_total_page: 1,
      id_10_name:'',
      id_10_list:[],
      id_10_page: 1,
      id_10_current: [],
      id_10_total_page: 1,

      homeDaily:[],
      showNav: true,
    }
  },

  computed: {
    // getPublishActive() {
    //   return this.selected.publish
    // },
    // getVodHomeActive() {
    //   return this.selected.category
    // }
  },

  methods: {
    
    downloadAndroidApp() {
        window.location.href = commService.getLocalInitData().appDownloadUrl;
    },
    toVodSearch() {
        this.$router.push('/search-vod')
    },
    toHistory() {
        this.$router.push({path: '/shelf-vod', query: {active: 'shelf-vod'}})
    },
    toPurchase() {
        this.$router.push('/purchase')
    },
    getVodHome() {
      this.isLoading = true;
      vodService.getVodHome()
        .then(res => {
          this.homeShelves = res.data.shelves;
          this.shelfPage = res.data.shelfPage === 4 ? 1 : res.data.shelfPage + 1
          this.homeDaily = res.data.todayUpdate
          this.isLoading = false;
          for (const i in this.homeShelves) {
              switch(parseInt(this.homeShelves[i].typeId)){
                case 1:
                  this.id_1_name = this.homeShelves[i].typeName
                  this.id_1_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves1",JSON.stringify(this.homeShelves[i].vods));
                  this.id_1_total_page = Math.floor(this.homeShelves[i].vods.length / 3)             
                  //this.getVodCategory(1)
                  break;
                case 2:
                  this.id_2_name = this.homeShelves[i].typeName
                  this.id_2_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves2",JSON.stringify(this.homeShelves[i].vods));
                  this.id_2_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(2)
                  break;
                case 3:
                  this.id_3_name = this.homeShelves[i].typeName
                  this.id_3_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves3",JSON.stringify(this.homeShelves[i].vods));
                  this.id_3_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(3)
                  break;
                case 4:
                  this.id_4_name = this.homeShelves[i].typeName
                  this.id_4_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves4",JSON.stringify(this.homeShelves[i].vods));
                  this.id_4_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(4, 1)
                  break;
                case 5:
                  this.id_5_name = this.homeShelves[i].typeName
                  this.id_5_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves5",JSON.stringify(this.homeShelves[i].vods));
                  this.id_5_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(5)
                  break;
                case 6:
                  this.id_6_name = this.homeShelves[i].typeName
                  this.id_6_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves6",JSON.stringify(this.homeShelves[i].vods));
                  this.id_6_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(6)
                  break;
                case 7:
                  this.id_7_name = this.homeShelves[i].typeName
                  this.id_7_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves7",JSON.stringify(this.homeShelves[i].vods));
                  this.id_7_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(7)
                  break;
                case 8:
                  this.id_8_name = this.homeShelves[i].typeName
                  this.id_8_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves8",JSON.stringify(this.homeShelves[i].vods));
                  this.id_8_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(8)
                  break;
                case 9:
                  this.id_9_name = this.homeShelves[i].typeName
                  this.id_9_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves9",JSON.stringify(this.homeShelves[i].vods));
                  this.id_9_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(9)
                  break;
                case 10:
                  this.id_10_name = this.homeShelves[i].typeName
                  this.id_10_list = this.homeShelves[i].vods
                  window.localStorage.setItem("shelves10",JSON.stringify(this.homeShelves[i].vods));
                  this.id_10_total_page = Math.floor(this.homeShelves[i].vods.length / 3)                 
                  //this.getVodCategory(10)
                  break;
              }
            }
        })
    },
    //去搜索
    toVodSearch() {
      this.$router.isBack = true;
      this.$router.push({path: '/search-vod'});
    },
    //去排行榜
    toRanking() {
      this.$router.push('/vod/day-ranked')
    },

    toCategory(id){
      this.$router.isBack = false;
      if(id === 3){
        this.toRanking()
      }else{
        this.$router.push({
          path: '/vod/category',
          query: {
            cid: id
          }
        })
      }
    },
    //详情页
    toVodDetail(vod){
      this.$router.isBack = false;
      this.$router.push({
        path: '/vod/detail',
        query: {
          vodId: vod.vodId,
        }
      })
    },
    //取分页数据
    getVodCategory(category) {
        this.isLoading = true;
        vodService.getRefreshList(category, this.shelfPage)
          .then(res => {
            this.shelfPage = this.shelfPage === 4 ? 1 : this.shelfPage + 1
            switch(parseInt(category)){
              case 1:
                this.id_1_list = res.data.vods
                break;
              case 2:
                this.id_2_list = res.data.vods
                break;
              case 3:
                this.id_3_list = res.data.vods
                break;
              case 4:
              this.id_4_list = res.data.vods
                break;
              case 5:
              this.id_5_list = res.data.vods
                break;
              case 6:
              this.id_6_list = res.data.vods
                break;
              case 7:
              this.id_7_list = res.data.vods
                break;
              case 8:
              this.id_8_list = res.data.vods
                break;
              case 9:
              this.id_9_list = res.data.vods
                break;
              case 10:
              this.id_10_list = res.data.vods
                break;
            }
            this.isLoading = false;
          })
    },


  },
  components: {
    vodBottom: vodBottom,
  },
  mounted() {
    this.userInfo = userService.getLocalUserInfo();

    this.inWebView = kkUtil.isInWebView();
    this.inAndroidBrowser = kkUtil.isInAndroidBrowser();
    this.inIosBrowser = kkUtil.isInIosBrowser();


    this.componentName = this.$route.name;
    console.log(this.componentName, this.$store.state.pageState[this.componentName]);
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-category');
        console.log(this.$store.state.pageState[this.$route.name].top);
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      this.getVodHome();
      //this.getVodHomeDaily();
    }
    this.$router.isBack = true;
  },
}
</script>

<style scoped>



.movie-index{  padding: 10px 10px 60px 10px; background: #202125;}
.movie-nav ul { display: flex; flex-wrap: wrap; margin-bottom: .3rem;}
.movie-nav ul li{ width:calc(20% - 0.4rem); text-align: center;  height: 3rem; line-height: 3rem; border-radius: .3rem;  margin: .2rem;
background: #fff;}
.movie-nav ul li span{ font-size:.6rem;height:2rem; line-height: 2rem; width: 2rem; margin: 0 auto;
  display: block; border-radius: 50%; overflow: hidden; font-weight: 500;
  box-shadow: 0 0.1rem 0.1rem rgba(158, 101, 243, 0.15);
  background: url(../../assets/images/icon-h3-0.png) center .3rem no-repeat; background-size: 75%;
  text-shadow:#fff 1px 0 0, #fff 1px 0 0, #fff 1px 0 0;}
.movie-nav ul li h5{font-size:.6rem; font-weight: 400; margin: 0; padding: 0; line-height: 1rem; color: #fff;}
.movie-nav ul li:nth-child(1){background: linear-gradient(to bottom,#00aeff,#135371);}
.movie-nav ul li:nth-child(3){background: linear-gradient(to bottom,#00ff80,#206c75);}
.movie-nav ul li:nth-child(2){background: linear-gradient(to bottom,#ffba00,#aa7f06);}
.movie-nav ul li:nth-child(4){background: linear-gradient(to bottom,#cf54f8,#9110a0);}
.movie-nav ul li:nth-child(5){background: linear-gradient(to bottom,#9dff00,#4d760c);}
.movie-nav ul li:nth-child(6){background: linear-gradient(to bottom,#ffba00,#ff4400);}
.movie-nav ul li:nth-child(7){background: linear-gradient(to bottom,#00ff80,#386816);}
.movie-nav ul li:nth-child(8){background: linear-gradient(to bottom,#8d1bff,#122fa4);}
.movie-nav ul li:nth-child(9){background: linear-gradient(to bottom,#40ff00,#a77b04);}
.movie-nav ul li:nth-child(10){background: linear-gradient(to bottom,#ff0077,#ffba00);}

.movie-bn{ border-radius: 10px; margin-bottom: 0px; overflow: hidden; padding: 0;}
.movie-bn img{ width: 100%;border-radius: 10px;  }
.movie-box{  border-radius: 10px; background: #fff; margin-bottom: 15px; }

.movie-box-flex{overflow-x: scroll; overflow-y: hidden; display: flex; flex-wrap: wrap; min-height: 8rem; }

.f-x{width: 74rem; height: 7.4rem;margin-left: .3rem; display: flex; flex-wrap: nowrap; margin: .2rem 0 .3rem 0;}
.movie-box .f-x .item{ width: 7rem;margin: 0.2rem 0.15rem; border:.12rem solid #fff980; border-radius: .4rem; overflow: hidden; position: relative;}
.movie-box .f-x .item a{ height: 5rem;}
.movie-box .f-x .ico{background: url(../../assets/images/i6.png) center center no-repeat; background-size: 100% auto; position: absolute; right: 0rem; top:0rem; width: 1.5rem; height: 1.5rem;}
.movie-box h3{padding: 0.2rem 0 0.3rem 0;height: 1rem; line-height: 1rem; border-bottom: 1px solid #EEE;}
.movie-box h3 span{padding-left: 35px; font-size: .7rem; color: #735100;font-weight: 500;
  background: url(../../assets/images/icon-h3-2.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-1{background: url(../../assets/images/icon-h3-3.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-2{background: url(../../assets/images/icon-h3-2.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-3{background: url(../../assets/images/icon-h3-1.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-4{background: url(../../assets/images/icon-h3-10.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-5{background: url(../../assets/images/icon-h3-4.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-6{background: url(../../assets/images/icon-h3-5.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-7{background: url(../../assets/images/icon-h3-9.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-8{background: url(../../assets/images/icon-h3-6.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-9{background: url(../../assets/images/icon-h3-8.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-10{background: url(../../assets/images/icon-h3-7.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-new{background: url(../../assets/images/i17.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 i{ float: right; font-size: .5rem; margin-right: 8px; color: #fff; font-style: normal;  margin-top: 3px;}
.movie-box .item{ background: #fff; padding: 0 0 0 0; margin: 0.2rem 2%; width: 46%;box-sizing: content-box; border-radius: 5px;}
.movie-box .item a {
  background: #1a1a1a url(../../assets/img/loading_ho2.jpg) center center no-repeat; background-size:40px;
  position: relative;
  display: block;
  /* padding-top: 68%; */
  height: 6rem;
  border-radius: 4px;
  overflow: hidden;}
.movie-box .item a img{ width: 100%; height: 100%; vertical-align: middle; }
.movie-box .item h5{
  color: #333;
  font-size: .55rem;
  height: 1.4rem;
  line-height: .8rem; font-weight: 600;
  overflow: hidden;
  padding:.2rem;}
.movie-box-home{    background: linear-gradient(135deg, #006757 0%, #b8be00 100%);}
.movie-box-home h3{    border-bottom: 1px solid #58814f;}
.movie-box-home h3 span{color: #fff;}

.nav-on{ height: 1rem; line-height: 1rem; font-size: .5rem; text-align: center; color: #fb4447;
  width: 5rem; margin: 0 auto 0 auto; border-radius: 5px; border: 1px solid #fb4447; margin-bottom: 5px;}
.search-word{ margin-bottom: 8px !important;}
.loadingBox{ position: fixed; top: calc(50% - 40px); left: calc(50% - 40px); width: 80px; height: 80px; line-height: 140px; overflow: hidden;
  background: #000 url(../../assets/img/loading.gif) center -20px no-repeat; background-size:110px ; color: #ccc; text-align: center; font-size: 12px; border-radius: 10px;}

  .movie-box i{line-height:1rem;  width: 2.6rem;font-size: .5rem;color: #fff;font-weight: 500;text-align: center; margin-right:0.5rem;
  border-radius: 0.5rem;background:#65655d;color: #fff; font-weight: 400;}
  .movie-box i.refresh{background:#65655d url(../../assets/images/i7.png) 0.4rem center no-repeat; background-size: 0.5rem; padding-left: 0.6rem; }

  .movie-box-flex .item a .vip-free{ position: absolute; top: .2rem; left:.2rem; width: 3rem; height: 1rem;
  background: #000  url(../../assets/images/i18.jpg) center center no-repeat; background-size:100% auto; border-radius: .1rem;}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/vod.vue